import { ArrowUpRight } from "lucide-react";
import { ADDRESS, IMG, LINKS } from "../data/content";

export default function Footer() {
  return (
    <footer className="border-t border-neon/10 bg-coal px-5 pb-28 pt-14 sm:px-8 md:pb-14" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col gap-10 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-3">
            <img src={IMG.logo} alt="Brewing Bistro logo" className="h-11 w-11 rounded-full ring-1 ring-neon/40" />
            <p className="font-serif text-2xl text-cream">
              Brewing <span className="italic text-neon">Bistro</span>
            </p>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-mist">{ADDRESS}</p>
          <p className="mt-6 font-serif text-lg italic text-cream/60">Brewed with love in Baner.</p>
        </div>

        <div className="flex flex-col gap-3 font-mono text-xs uppercase tracking-[0.2em]">
          <a
            href={LINKS.maps}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-maps-link"
            className="group flex items-center gap-2 text-sage transition-colors hover:text-neon"
          >
            Google Maps <ArrowUpRight size={13} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
          <a
            href={LINKS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="group flex items-center gap-2 text-sage transition-colors hover:text-neon"
          >
            Instagram <ArrowUpRight size={13} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
          <a
            href={LINKS.zomato}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-zomato-link"
            className="group flex items-center gap-2 text-sage transition-colors hover:text-neon"
          >
            Zomato <ArrowUpRight size={13} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
        </div>
      </div>
      <p className="mx-auto mt-12 max-w-7xl border-t border-cream/8 pt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-mist/60">
        © {new Date().getFullYear()} Brewing Bistro · Baner, Pune
      </p>
    </footer>
  );
}
